import { useAuth } from "../../contexts/AuthContext";

interface HeaderProps {
  onToggleSidebar: () => void;
  title?: string;
  unreadMessages?: number;
}

export function Header({ onToggleSidebar, title = "Dashboard", unreadMessages = 0 }: HeaderProps) {
  const { client, logout } = useAuth();

  const initial = client?.name?.charAt(0).toUpperCase() || "C";

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-slate-200">
      <div className="flex items-center justify-between px-4 lg:px-6 py-3">
        <div className="flex items-center gap-3">
          <button
            onClick={onToggleSidebar}
            className="lg:hidden text-slate-600 hover:text-slate-900 text-2xl leading-none"
            aria-label="Abrir menú"
          >
            ☰
          </button>
          <h1 className="text-lg lg:text-xl font-bold text-slate-900">{title}</h1>
        </div>

        <div className="flex items-center gap-4">
          <div className="hidden sm:flex flex-col items-end text-right">
            <span className="text-sm font-semibold text-slate-900">{client?.name}</span>
            <span className="text-xs text-slate-500">Cliente</span>
          </div>
          <div className="w-10 h-10 rounded-full bg-primary-light text-primary flex items-center justify-center font-bold">
            {initial}
          </div>
          <button
            onClick={logout}
            className="hidden sm:inline-flex text-sm bg-red-50 text-red-600 hover:bg-red-100 px-3 py-1.5 rounded-lg font-medium transition"
          >
            Salir
          </button>
        </div>
      </div>
    </header>
  );
}